import React from "react";
import { Reveal } from "./Reveal";

export const SectionHeading = ({ overline, title, className = "", align = "left" }) => (
  <div className={`${align === "center" ? "text-center mx-auto" : ""} max-w-3xl ${className}`}>
    <Reveal>
      <span className="text-xs tracking-[0.28em] uppercase font-mono text-[#60A5FA] flex items-center gap-3">
        <span className="inline-block h-px w-8 bg-[#60A5FA]/50" />
        {overline}
      </span>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-6 text-4xl sm:text-5xl md:text-6xl tracking-tighter font-medium text-white text-balance leading-[1.05]">
        {title}
      </h2>
    </Reveal>
  </div>
);
